// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3CS6h","unreadBadge":"styles_unreadBadge__PLR28","modalContent":"styles_modalContent__Zzo6P","modal":"styles_modal__GUMDy"};